module.exports = __webpack_public_path__ + "static/img/2.ab04c6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/2.png
// module id = mTsV
// module chunks = 0